import React from 'react'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import {
    LOWER_TEETH_FIRST_HALF,
    UPPER_TEETH_FIRST_HALF,
    LOWER_TEETH_SECOND_HALF,
    UPPER_TEETH_SECOND_HALF,
} from '../../../../treatment/state/plan/const'
import Select from '../../../../form/component/Select'
import SelectChip from '../../../../form/component/SelectChip'
import TextArea from '../../../../form/component/TextArea'
import LabelInput from '../../../../form/component/LabelInput'

const TOOTH_INDICATION = ['b', 'f', 'i', 'ix', 'k', 'kw', 'sw', 'x', ')(', 'S'].map(indication => ({
    id: indication,
    value: indication,
}))

const ADDITIONAL_INDICATION = [
    {
        value: 'clinic_opb',
        label: ' No Findings',
    },
    {
        value: 'CMD_Kurzbefund_lt2',
        label: ' CMD (Yes)',
    },
    {
        value: 'CMD_Kurzbefund_gt2',
        label: ' CMD (No)',
    },
    {
        value: 'parodontitis',
        label: 'PSI >3 (Periodontitis)',
    },
    {
        value: 'WKB_unabgeschlossen',
        label: 'Root canal treatment needed or not finished',
    },
    {
        value: 'other',
        label: 'Other (write in general comments)',
    },
]

const EditTreatmentExpectationButton = ({
    toggleEditingTreatmentExpectation,
    isEditingTreatmentExpectation,
    readOnly,
    saveAnamnesis,
    anamnesis
}) => (
        <button
            className="btn btn-primary btn-md "
            onClick={() => {
                if (readOnly) {
                    return ;
                }
                if (isEditingTreatmentExpectation) {
                    saveAnamnesis(anamnesis.templateKey)
                }
                toggleEditingTreatmentExpectation()
            }}
        >
            {isEditingTreatmentExpectation ? 'Save Comment' : 'Edit Comment'}
        </button>
    )

const ToothCell = ({
    position,
    teethIndication = {},
    readOnly,
    changeToothIndication,
}) => {
    return (
        <td className={'teeth-cell-' + position}>
            <Select
                addEmpty={true}
                readOnly={readOnly}
                object={teethIndication}
                onChange={changeToothIndication}
                valueList={TOOTH_INDICATION}
                name={position}
            />
        </td>
    )
}

const InfoLegendDiv = ({ children }) => (
    <div className="info-legend-div">{children}</div>
)

const InfoLegend = ({ isInfoLegendShown, toggleInfoLegend }) => (
    <div className="tooltip">
        <button
            onClick={() => {
                toggleInfoLegend()
            }}
            className=" btn-primary btn-md info-button"
        >
            i
        </button>
        {isInfoLegendShown && (
            <span className="tooltiptext teethLegend">
                <p>b = Brückenglied</p>
                <p>f = fehlender Zahn</p>
                <p>i = Implantat mit intakter Suprakonstruktion</p>
                <p>ix = zu entfernendes Implantat</p>
                <p>k = klinisch intakte Krone</p>
                <p>kw = erneuerungsbedürftige Krone</p>
                <p>sw = erneuerungsbedürftige Suprakonstruktion</p>
                <p>x = nicht erhaltungswürdiger Zahn</p>
                <p>)( = Lückenschluss</p>
                <p>S = Implantatgetragene Suprakonstruktion geplant</p>
            </span>
        )}
    </div>
)

const ImplantTreatmentPhysicianAssessment = ({
    anamnesis,
    readOnly,
    changeAnamnesis,
    saveAnamnesis,
    toggleEditingTreatmentExpectation,
    isEditingTreatmentExpectation,
    isInfoLegendShown,
    toggleInfoLegend,
}) => {

    const changeAndSaveFormData = formData => {
        changeAnamnesis('formData', formData, anamnesis.templateKey)
        saveAnamnesis(anamnesis.templateKey)
    }

    const changeFormData = (name, value) => {
        changeAndSaveFormData({
            ...anamnesis.formData,
            [name]: value,
        })
    }

    if (!anamnesis.formData) {
        return null
    }

    const changeToothIndication = (name, value) => {
        changeAndSaveFormData({
            ...anamnesis.formData,
            teethIndication: {
                ...anamnesis.formData.teethIndication,
                [name]: value,
            },
        })
    }

    const TeethRow = ({ upperTeeth, lowerTeeth }) => (
        <React.Fragment>
            {upperTeeth && (
                <tr>
                    {upperTeeth.map(position => {
                        return <td key={position}>{position}</td>
                    })}
                </tr>
            )}
            <tr>
                {(upperTeeth || lowerTeeth).map(position => {
                    return (
                        <ToothCell
                            key={position}
                            changeToothIndication={changeToothIndication}
                            readOnly={readOnly}
                            teethIndication={anamnesis.formData.teethIndication}
                            position={position}
                        />
                    )
                })}
            </tr>
            {lowerTeeth && (
                <tr>
                    {lowerTeeth.map(position => {
                        return <td key={position}>{position}</td>
                    })}
                </tr>
            )}
        </React.Fragment>
    )
    return (
        <div>
            <InfoLegendDiv>
                <InfoLegend
                    isInfoLegendShown={isInfoLegendShown}
                    toggleInfoLegend={toggleInfoLegend}
                />
            </InfoLegendDiv>

            <Row top="M" className="teeth-table-whole-div">
                <Column
                    size={6}
                    layer="lg"
                    className="no-padding teeth-table-right-border"
                >
                    <table className="teeth-table">
                        <tbody>
                            <TeethRow upperTeeth={UPPER_TEETH_FIRST_HALF} />
                            <TeethRow lowerTeeth={LOWER_TEETH_FIRST_HALF} />
                        </tbody>
                    </table>
                </Column>
                <hr className="teeth-table-divider" />
                <div className="teeth-table-divider-horizontal" />
                <Column size={6} layer="lg" className="no-padding">
                    <table className="teeth-table">
                        <tbody>
                            <TeethRow upperTeeth={UPPER_TEETH_SECOND_HALF} />
                            <TeethRow lowerTeeth={LOWER_TEETH_SECOND_HALF} />
                        </tbody>
                    </table>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <LabelInput label="Findings">
                        <SelectChip
                            object={anamnesis.formData}
                            name="additionalIndication"
                            readOnly={readOnly}
                            addEmpty={true}
                            valueList={ADDITIONAL_INDICATION}
                            onChange={changeFormData}
                        />
                    </LabelInput>
                </Column>
            </Row>
            <Row top="M">
                <Column size={12}>
                    <LabelInput label="Patients wishes">
                        <TextArea
                            name="treatmentExpectation"
                            object={anamnesis.formData}
                            onChange={(name, value) => {
                                changeAnamnesis('formData', {
                                    ...anamnesis.formData,
                                    [name]: value,
                                }, anamnesis.templateKey)
                            }}
                            className="textarea-treatment-expectation"
                            readOnly={!isEditingTreatmentExpectation}
                        />
                    </LabelInput>
                    <EditTreatmentExpectationButton
                        {...{
                            toggleEditingTreatmentExpectation,
                            isEditingTreatmentExpectation,
                            readOnly,
                            saveAnamnesis,
                            anamnesis,
                        }}
                    />
                </Column>
            </Row>
        </div>
    )
}

export default ImplantTreatmentPhysicianAssessment



// WEBPACK FOOTER //
// ./src/modules/anamnesis/component/anamnesis/renderer/ImplantTreatmentPhysicianAssessment.js